import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@utils/seo";
import i18n from "@modules/shared/localization/i18n";
import { WithdrawalForm } from "@modules/shop/components/Withdrawal/WithdrawalForm";

export const Route = createFileRoute(
  "/$locale/_layout/(public)/_public/info/withdraw",
)({
  component: WithdrawPage,
  ssr: true,
  headers: () => ({
    "Cache-Control":
      "public, max-age=3600, s-maxage=3600, stale-while-revalidate=86400",
  }),
  head: ({ params }) => {
    const t = i18n.getFixedT(params.locale);
    return {
      meta: [
        ...seo({
          title: t("Seo:withdraw.title"),
          description: t("Seo:withdraw.description"),
        }),
      ],
    };
  },
});

function WithdrawPage() {
  const { locale } = Route.useParams();
  return <WithdrawalForm locale={locale} />;
}
